import React from 'react'

const Calendar = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 448 512"
            style={props.style}
        >
            <path
                fill="currentColor"
                d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
            />
        </svg>
    )
}

const Clock = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 512 512"
            style={props.style}
        >
            <path
                fill="currentColor"
                d="M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
            />
        </svg>
    )
}

const Close = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 150 150"
            style={props.style}
            className={props.className}
        >
            <g transform="matrix(7.5,0,0,7.5,-15,-15)">
                <path
                    d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2ZM15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

const Checkmark = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 150 150"
            style={props.style}
            className={props.className}
        >
            <g transform="matrix(7.5,0,0,7.5,-15,-15)">
                <path
                    d="M12,2C17.523,2 22,6.477 22,12C22,17.523 17.523,22 12,22C6.477,22 2,17.523 2,12C2,6.477 6.477,2 12,2ZM11,16.502L18,9.502L16.586,8.088L11,13.674L7.914,10.588L6.5,12.002L11,16.502Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

const Arrow = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 448 512"
            style={props.style}
            className={`${props.className} svg-arrow svg-arrow--${props.direction}`}
        >
            <path
                d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                fill="currentColor"
            />
        </svg>
    )
}

const UKFlag = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 60 30"
            style={props.style}
            className={`${props.className} svg-arrow`}
            width="2.5rem"
            height="1.5rem"
        >
            <clipPath id="s">
                <path d="M0,0 v30 h60 v-30 z" />
            </clipPath>
            <clipPath id="t">
                <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
            </clipPath>
            <g clipPath="url(#s)">
                <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </g>
        </svg>
    )
}

const CzechFlag = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={props.style}
            className={`${props.className} svg-arrow`}
            viewBox="0 0 900 600"
        >
            <rect width="900" height="600" fill="#d7141a" />
            <rect width="900" height="300" fill="#fff" />
            <path d="M 450,300 0,0 V 600 z" fill="#11457e" />
        </svg>
    )
}

const TemperatureOut = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={props.style}
            className={props.className}
            viewBox="0 0 512 512"
        >
            <g id="Layer1">
                <g transform="matrix(0.695703,0,0,0.695703,333.9,0)">
                    <path
                        d="M192,384C192,419.346 163.346,448 128,448C92.654,448 64,419.346 64,384C64,360.315 76.876,339.651 96,328.583L96,224C96,206.327 110.327,192 128,192C145.673,192 160,206.327 160,224L160,328.583C179.124,339.651 192,360.315 192,384ZM224,299.347C243.912,321.91 256,351.541 256,384C256,454.696 198.697,512 128,512C127.701,512 127.391,511.999 127.091,511.997C56.789,511.509 -0.357,453.636 0.002,383.333C0.166,351.135 12.225,321.755 32,299.347L32,96C32,42.981 74.981,0 128,0C181.019,0 224,42.981 224,96L224,299.347ZM208,384C208,349.661 188.63,331.81 176,317.498L176,96C176,69.533 154.467,48 128,48C101.533,48 80,69.533 80,96L80,317.498C67.268,331.926 48.175,349.598 48.001,383.578C47.777,427.454 83.564,463.694 127.424,463.998L128,464C172.112,464 208,428.112 208,384Z"
                        fill="currentColor"
                    />
                </g>
                <g transform="matrix(0.915765,0,0,0.915765,0.000374987,43.1194)">
                    <path
                        d="M378.31,378.49L298.42,288L329.05,288C338.06,288 346.03,283 349.83,274.94C353.63,266.9 352.38,257.68 346.55,250.89L268.42,160L297.31,160C306.41,160 314.61,154.65 318.17,146.39C321.69,138.26 320.03,128.8 313.93,122.31L203.66,4.83C197.63,-1.62 186.38,-1.62 180.34,4.83L70.06,122.31C63.96,128.8 62.31,138.26 65.82,146.39C69.38,154.65 77.59,160 86.69,160L115.58,160L37.44,250.91C31.63,257.69 30.38,266.9 34.17,274.95C37.97,283 45.93,288 54.95,288L85.58,288L5.69,378.49C-0.31,385.28 -1.67,394.58 2.13,402.75C5.88,410.8 14.13,416 23.14,416L160,416L160,440.45L129.71,488.85C124.39,499.49 132.13,512.01 144.02,512.01L239.98,512.01C251.87,512.01 259.61,499.49 254.29,488.85L224,440.45L224,416L360.86,416C369.87,416 378.12,410.8 381.87,402.75C385.67,394.58 384.31,385.28 378.31,378.49Z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
}

const TemperaturePanel = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={props.className}
            style={props.style}
            viewBox="0 0 512 512"
        >
            <path
                d="M512,56.32C512,25.236 486.764,0 455.68,0L56.32,0C25.236,0 0,25.236 0,56.32L0,455.68C0,486.764 25.236,512 56.32,512L455.68,512C486.764,512 512,486.764 512,455.68L512,56.32ZM462.177,56.32L462.177,455.68C462.177,459.266 459.266,462.177 455.68,462.177L56.32,462.177C52.734,462.177 49.823,459.266 49.823,455.68L49.823,56.32C49.823,52.734 52.734,49.823 56.32,49.823L455.68,49.823C459.266,49.823 462.177,52.734 462.177,56.32ZM453.03,379.678C453.03,373.72 448.193,368.882 442.234,368.882L367.165,368.882C361.206,368.882 356.369,373.72 356.369,379.678L356.369,441.133C356.369,447.092 361.206,451.93 367.165,451.93L442.234,451.93C448.193,451.93 453.03,447.092 453.03,441.133L453.03,379.678ZM157.03,379.678C157.03,373.72 152.193,368.882 146.234,368.882L71.165,368.882C65.206,368.882 60.369,373.72 60.369,379.678L60.369,441.133C60.369,447.092 65.206,451.93 71.165,451.93L146.234,451.93C152.193,451.93 157.03,447.092 157.03,441.133L157.03,379.678ZM316.26,289.082C328.759,303.245 336.346,321.844 336.346,342.219C336.346,386.595 300.377,422.566 256,422.566C255.812,422.566 255.618,422.565 255.429,422.564C211.3,422.257 175.429,385.93 175.655,341.8C175.758,321.589 183.327,303.147 195.74,289.082L195.74,161.439C195.74,128.159 222.719,101.179 256,101.179C289.28,101.179 316.26,128.159 316.26,161.439L316.26,289.082ZM306.216,342.219C306.216,320.664 294.058,309.459 286.13,300.475L286.13,161.439C286.13,144.826 272.613,131.309 256,131.309C239.386,131.309 225.87,144.826 225.87,161.439L225.87,300.475C217.878,309.532 205.893,320.625 205.784,341.954C205.643,369.495 228.107,392.244 255.638,392.434L256,392.436C283.689,392.436 306.216,369.909 306.216,342.219ZM296.173,342.219C296.173,364.406 278.187,382.392 256,382.392C233.813,382.392 215.827,364.406 215.827,342.219C215.827,327.352 223.909,314.381 235.913,307.433L235.913,241.786C235.913,230.692 244.906,221.699 256,221.699C267.093,221.699 276.087,230.692 276.087,241.786L276.087,307.433C288.091,314.381 296.173,327.352 296.173,342.219ZM453.03,272.669C453.03,266.71 448.193,261.873 442.234,261.873L367.165,261.873C361.206,261.873 356.369,266.71 356.369,272.669L356.369,334.124C356.369,340.082 361.206,344.92 367.165,344.92L442.234,344.92C448.193,344.92 453.03,340.082 453.03,334.124L453.03,272.669ZM157.03,272.669C157.03,266.71 152.193,261.873 146.234,261.873L71.165,261.873C65.206,261.873 60.369,266.71 60.369,272.669L60.369,334.124C60.369,340.082 65.206,344.92 71.165,344.92L146.234,344.92C152.193,344.92 157.03,340.082 157.03,334.124L157.03,272.669ZM453.03,170.915C453.03,164.956 448.193,160.119 442.234,160.119L367.165,160.119C361.206,160.119 356.369,164.956 356.369,170.915L356.369,232.37C356.369,238.328 361.206,243.166 367.165,243.166L442.234,243.166C448.193,243.166 453.03,238.328 453.03,232.37L453.03,170.915ZM157.03,170.915C157.03,164.956 152.193,160.119 146.234,160.119L71.165,160.119C65.206,160.119 60.369,164.956 60.369,170.915L60.369,232.37C60.369,238.328 65.206,243.166 71.165,243.166L146.234,243.166C152.193,243.166 157.03,238.328 157.03,232.37L157.03,170.915ZM453.03,69.169C453.03,63.21 448.193,58.373 442.234,58.373L367.165,58.373C361.206,58.373 356.369,63.21 356.369,69.169L356.369,130.624C356.369,136.582 361.206,141.42 367.165,141.42L442.234,141.42C448.193,141.42 453.03,136.582 453.03,130.624L453.03,69.169ZM157.03,69.169C157.03,63.21 152.193,58.373 146.234,58.373L71.165,58.373C65.206,58.373 60.369,63.21 60.369,69.169L60.369,130.624C60.369,136.582 65.206,141.42 71.165,141.42L146.234,141.42C152.193,141.42 157.03,136.582 157.03,130.624L157.03,69.169Z"
                fill="currentColor"
            />
        </svg>
    )
}

const Sun = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={props.className}
            style={props.style}
            viewBox="0 0 512 512"
        >
            <path
                fill="currentColor"
                d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
            />
        </svg>
    )
}

const MarkerIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={props.className}
            style={props.style}
            viewBox="0 0 384 512"
        >
            <path
                fill="currentColor"
                d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
            />
        </svg>
    )
}
/*
const Transformator = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			className={props.className}
			style={props.style}
			viewBox="0 0 196 296">
			<g id="path861" transform="matrix(1,0,0,1,-22.5027,-22.5027)">
				<path d="M28.346,28.346L85.039,28.346C113.386,28.346 113.386,56.693 85.039,56.693C113.386,56.693 113.386,85.039 85.039,85.039C113.386,85.039 113.386,113.386 85.039,113.386C113.386,113.386 113.386,141.732 85.039,141.732C113.386,141.732 113.386,170.079 85.039,170.079C113.386,170.079 113.386,198.425 85.039,198.425C113.386,198.425 113.386,226.772 85.039,226.772C113.386,226.772 113.386,255.118 85.039,255.118C113.386,255.118 113.386,283.465 85.039,283.465C113.386,283.465 113.386,311.811 85.039,311.811L28.346,311.811" strokeWidth="2.83px" stroke="currentColor" fill="none" />
			</g>
			<g id="path865" transform="matrix(1,0,0,1,-22.5027,-22.5027)">
				<path d="M212.598,28.346L155.905,28.346C127.559,28.346 127.559,56.693 155.905,56.693C127.559,56.693 127.559,85.039 155.905,85.039C127.559,85.039 127.559,113.386 155.905,113.386C127.559,113.386 127.559,141.732 155.905,141.732C127.559,141.732 127.559,170.079 155.905,170.079C127.559,170.079 127.559,198.425 155.905,198.425C127.559,198.425 127.559,226.772 155.905,226.772C127.559,226.772 127.559,255.118 155.905,255.118C127.559,255.118 127.559,283.465 155.905,283.465C127.559,283.465 127.559,311.811 155.905,311.811L212.598,311.811" strokeWidth="2.83px" stroke="currentColor" fill="none" />
			</g>
			<g id="rect873" transform="matrix(1,0,0,1,-22.5027,-22.5027)">
				<rect x="116.22" y="28.346" width="8.505" height="283.465" fill="currentColor" />
			</g>
		</svg>
	)
}
*/
const Transformator = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 11">
            <g fill="none" stroke="#000" transform="translate(0 .5)">
                <circle cx="10" cy="5" r="5" opacity="0.999"></circle>
                <circle cx="15" cy="5" r="5" opacity="0.999"></circle>
                <path d="M0 5h5M20 5h5"></path>
            </g>
        </svg>
    )
}

const TransformatorLandscape = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={props.className}
            style={props.style}
            viewBox="0 0 296 196"
        >
            <g id="path861" transform="matrix(6.12323e-17,-1,1,6.12323e-17,-22.0787,218.598)">
                <path
                    d="M28.346,28.346L85.039,28.346C113.386,28.346 113.386,56.693 85.039,56.693C113.386,56.693 113.386,85.039 85.039,85.039C113.386,85.039 113.386,113.386 85.039,113.386C113.386,113.386 113.386,141.732 85.039,141.732C113.386,141.732 113.386,170.079 85.039,170.079C113.386,170.079 113.386,198.425 85.039,198.425C113.386,198.425 113.386,226.772 85.039,226.772C113.386,226.772 113.386,255.118 85.039,255.118C113.386,255.118 113.386,283.465 85.039,283.465C113.386,283.465 113.386,311.811 85.039,311.811L28.346,311.811"
                    strokeWidth="2.83px"
                    stroke="currentColor"
                    fill="none"
                />
            </g>
            <g id="path865" transform="matrix(6.12323e-17,-1,1,6.12323e-17,-22.0787,218.598)">
                <path
                    d="M212.598,28.346L155.905,28.346C127.559,28.346 127.559,56.693 155.905,56.693C127.559,56.693 127.559,85.039 155.905,85.039C127.559,85.039 127.559,113.386 155.905,113.386C127.559,113.386 127.559,141.732 155.905,141.732C127.559,141.732 127.559,170.079 155.905,170.079C127.559,170.079 127.559,198.425 155.905,198.425C127.559,198.425 127.559,226.772 155.905,226.772C127.559,226.772 127.559,255.118 155.905,255.118C127.559,255.118 127.559,283.465 155.905,283.465C127.559,283.465 127.559,311.811 155.905,311.811L212.598,311.811"
                    strokeWidth="2.83px"
                    stroke="currentColor"
                    fill="none"
                />
            </g>
            <g id="rect873" transform="matrix(6.12323e-17,-1,1,6.12323e-17,-22.0787,218.598)">
                <rect x="116.22" y="28.346" width="8.505" height="283.465" fill="currentColor" />
            </g>
        </svg>
    )
}

const North = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={props.className}
            style={props.style}
            viewBox="0 0 512 512"
        >
            <path
                d="M397.344,216.64L269.664,7.68C266.752,2.912,261.568,0,256,0s-10.752,2.912-13.664,7.648l-127.68,208.96
			c-4.16,6.784-2.656,15.616,3.488,20.704c6.112,5.024,15.072,4.832,20.96-0.544C170.688,207.904,212.224,192,256,192
			s85.312,15.904,116.896,44.768c5.856,5.344,14.784,5.568,20.96,0.544C400,232.224,401.504,223.392,397.344,216.64z"
                fill="currentColor"
            />
            <path
                d="M256,224c-79.392,0-144,64.608-144,144s64.608,144,144,144s144-64.608,144-144S335.392,224,256,224z M304,432
			c0,7.392-5.088,13.888-12.32,15.552c-1.248,0.32-2.464,0.448-3.68,0.448c-5.984,0-11.552-3.328-14.304-8.832L240,371.776V432
			c0,8.832-7.168,16-16,16c-8.832,0-16-7.168-16-16V304c0-7.392,5.12-13.888,12.32-15.552c7.136-1.856,14.656,1.792,17.984,8.416
			L272,364.224V304c0-8.832,7.168-16,16-16c8.832,0,16,7.168,16,16V432z"
                fill="currentColor"
            />
        </svg>
    )
}

const CardinalDirections = (props) => {
    return (
        <svg viewBox="0 0 600 600" id="svg2" className={props.className} style={props.style}>
            <g id="layer2">
                <g transform="translate(-56.88765,-38.38015)" id="g11797">
                    <path
                        d="M 330.74501,304.6637 L 363.57811,337.4968 L 363.56214,337.4968 L 120.71013,337.4968 L 330.74501,304.6637"
                        style={{
                            fill: '#ffffff',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path2122"
                    />
                    <path
                        d="M 330.74501,371.3299 L 363.57811,338.4968 L 363.56214,338.4968 L 120.71013,338.4968 L 330.74501,371.3299"
                        style={{
                            fill: '#000000',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path5805"
                    />
                    <path
                        d="M 397.41118,371.32995 L 364.57808,338.49685 L 364.59405,338.49685 L 607.44606,338.49685 L 397.41118,371.32995"
                        style={{
                            fill: '#ffffff',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path8724"
                    />
                    <path
                        d="M 397.41118,304.66375 L 364.57808,337.49685 L 364.59405,337.49685 L 607.44606,337.49685 L 397.41118,304.66375"
                        style={{
                            fill: '#000000',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path8726"
                    />
                    <path
                        d="M 330.74499,371.32988 L 363.57809,338.49678 L 363.57809,338.51275 L 363.57809,581.36476 L 330.74499,371.32988"
                        style={{
                            fill: '#ffffff',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path8740"
                    />
                    <path
                        d="M 397.41119,371.32988 L 364.57809,338.49678 L 364.57809,338.51275 L 364.57809,581.36476 L 397.41119,371.32988"
                        style={{
                            fill: '#000000',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path8742"
                    />
                    <path
                        d="M 397.41115,304.66372 L 364.57805,337.49682 L 364.57805,337.48085 L 364.57805,94.62884 L 397.41115,304.66372"
                        style={{
                            fill: '#ffffff',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path8746"
                    />
                    <path
                        d="M 330.74495,304.66372 L 363.57805,337.49682 L 363.57805,337.48085 L 363.57805,94.62884 L 330.74495,304.66372"
                        style={{
                            fill: '#000000',
                            fillOpacity: '1',
                            fillRule: 'evenodd',
                            stroke: '#000000',
                            strokeWidth: '1',
                            strokeLinecap: 'square',
                            strokeLinejoin: 'miter',
                            strokeMiterlimit: '4',
                            strokeDasharray: 'none',
                            strokeOpacity: '1',
                            display: 'inline',
                        }}
                        id="path8748"
                    />
                </g>
            </g>
            <g id="layer5">
                <path
                    d="M 294.12404,12.387486 L 302.52247,12.387486 L 313.12794,32.387486 L 313.12794,12.387486 L 320.25685,12.387486 L 320.25685,41.547642 L 311.85841,41.547642 L 301.25294,21.547642 L 301.25294,41.547642 L 294.12404,41.547642 L 294.12404,12.387486"
                    style={{
                        fontSize: '40px',
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'bold',
                        fontStretch: 'normal',
                        textAlign: 'start',
                        lineHeight: '125%',
                        writingMode: 'lr-tb',
                        textAnchor: 'start',
                        fill: 'black',
                        fillOpacity: '1',
                        stroke: 'none',
                        strokeWidth: '1px',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeOpacity: '1',
                        display: 'inline',
                        fontFamily: 'Bitstream Vera Sans',
                    }}
                    id="path1476"
                />
                <path
                    d="M 572.23012,285.03658 L 592.52309,285.03658 L 592.52309,290.72017 L 579.74965,290.72017 L 579.74965,296.14985 L 591.76137,296.14985 L 591.76137,301.83345 L 579.74965,301.83345 L 579.74965,308.51314 L 592.95277,308.51314 L 592.95277,314.19673 L 572.23012,314.19673 L 572.23012,285.03658"
                    style={{
                        fontSize: '40px',
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'bold',
                        fontStretch: 'normal',
                        textAlign: 'start',
                        lineHeight: '125%',
                        writingMode: 'lr-tb',
                        textAnchor: 'start',
                        fill: 'black',
                        fillOpacity: '1',
                        stroke: 'none',
                        strokeWidth: '1px',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeOpacity: '1',
                        display: 'inline',
                        fontFamily: 'Bitstream Vera Sans',
                    }}
                    id="path1478"
                />
                <path
                    d="M 9,285.03658 L 16.207031,285.03658 L 21.246094,306.22798 L 26.246094,285.03658 L 33.492187,285.03658 L 38.492187,306.22798 L 43.531253,285.03658 L 50.679687,285.03658 L 43.804683,314.19673 L 35.132812,314.19673 L 29.839844,292.02875 L 24.605469,314.19673 L 15.933594,314.19673 L 9,285.03658"
                    style={{
                        fontSize: '40px',
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'bold',
                        fontStretch: 'normal',
                        textAlign: 'start',
                        lineHeight: '125%',
                        writingMode: 'lr-tb',
                        textAnchor: 'start',
                        fill: 'black',
                        fillOpacity: '1',
                        stroke: 'none',
                        strokeWidth: '1px',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeOpacity: '1',
                        display: 'inline',
                        fontFamily: 'Bitstream Vera Sans',
                    }}
                    id="path1480"
                />
                <path
                    d="M 316.7803,560.1914 L 316.7803,566.36328 C 315.1787,565.64716 313.6162,565.10679 312.09279,564.74218 C 310.56933,564.37763 309.13053,564.19533 307.77639,564.19531 C 305.97949,564.19533 304.65137,564.44273 303.79201,564.9375 C 302.93263,565.43231 302.50293,566.20054 302.50295,567.24218 C 302.50293,568.02346 302.78941,568.63543 303.36231,569.07812 C 303.94824,569.50783 305.00293,569.87892 306.52639,570.1914 L 309.7295,570.83593 C 312.97168,571.48699 315.27637,572.47658 316.64357,573.80468 C 318.01074,575.13282 318.69433,577.02084 318.69435,579.46875 C 318.69433,582.6849 317.73731,585.08073 315.82325,586.65625 C 313.9222,588.21875 311.01205,589 307.09279,589 C 305.24381,589 303.38835,588.82422 301.52639,588.47265 C 299.6644,588.12109 297.80242,587.60026 295.94045,586.91015 L 295.94045,580.5625 C 297.80242,581.55209 299.59929,582.30078 301.33107,582.80859 C 303.07586,583.30339 304.75554,583.55078 306.37013,583.55078 C 308.01075,583.55078 309.26725,583.27735 310.13966,582.73047 C 311.01205,582.1836 311.44823,581.40235 311.44825,580.38672 C 311.44823,579.47527 311.14876,578.77214 310.54981,578.27734 C 309.96387,577.78256 308.7855,577.33985 307.01466,576.94922 L 304.1045,576.30468 C 301.18784,575.6797 299.05241,574.6836 297.69825,573.3164 C 296.35711,571.94923 295.68653,570.10679 295.68653,567.78906 C 295.68653,564.88544 296.62403,562.65237 298.49904,561.08984 C 300.37404,559.52737 303.06933,558.74612 306.58497,558.74609 C 308.18652,558.74612 309.83365,558.86982 311.52639,559.11718 C 313.21907,559.35159 314.97039,559.70966 316.7803,560.1914"
                    style={{
                        fontSize: '40px',
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'bold',
                        fontStretch: 'normal',
                        textAlign: 'start',
                        lineHeight: '125%',
                        writingMode: 'lr-tb',
                        textAnchor: 'start',
                        fill: 'black',
                        fillOpacity: '1',
                        stroke: 'none',
                        strokeWidth: '1px',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeOpacity: '1',
                        display: 'inline',
                        fontFamily: 'Bitstream Vera Sans',
                    }}
                    id="path1482"
                />
            </g>
        </svg>
    )
}
export {
    Calendar,
    Clock,
    Checkmark,
    Close,
    Arrow,
    UKFlag,
    CzechFlag,
    TemperatureOut,
    TemperaturePanel,
    Sun,
    MarkerIcon,
    Transformator,
    TransformatorLandscape,
    North,
    CardinalDirections,
}

// kate: replace-tabs on; tab-width 3; show-tabs on;
